import { css as c, LitElement as d, html as u } from "lit";
import { property as o, customElement as p } from "lit/decorators.js";
import { b as m, f as b } from "./styles-scZ6dVz-.js";
var f = Object.defineProperty, k = Object.getOwnPropertyDescriptor, a = (e, s, n, i) => {
  for (var t = i > 1 ? void 0 : i ? k(s, n) : s, h = e.length - 1, l; h >= 0; h--)
    (l = e[h]) && (t = (i ? l(s, n, t) : l(t)) || t);
  return i && t && f(s, n, t), t;
};
let r = class extends d {
  constructor() {
    super(...arguments), this.checked = !1, this.disabled = !1, this.name = "", this.value = "on";
  }
  handleChange(e) {
    e.stopPropagation(), !this.disabled && (this.checked = !this.checked, this.dispatchEvent(new CustomEvent("ark-change", {
      detail: { checked: this.checked, value: this.checked ? this.value : null },
      bubbles: !0,
      composed: !0
    })));
  }
  handleKeyDown(e) {
    this.disabled || (e.key === " " || e.key === "Enter") && (e.preventDefault(), this.handleChange(e));
  }
  render() {
    return u`
      <div 
        class="track" 
        @click=${this.handleChange}
        @keydown=${this.handleKeyDown}
        tabindex=${this.disabled ? -1 : 0}
        role="switch"
        aria-checked=${this.checked}
        aria-disabled=${this.disabled}
        class="track focus-ring"
      >
        <div class="thumb"></div>
      </div>
      <slot @click=${this.handleChange}></slot>
      <input
        type="checkbox"
        .checked=${this.checked}
        .name=${this.name}
        .value=${this.value}
        ?disabled=${this.disabled}
        @change=${this.handleChange}
        tabindex="-1"
      />
    `;
  }
};
r.styles = [
  m,
  b,
  c`
      :host {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-2);
        cursor: pointer;
      }

      :host([disabled]) {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .track {
        position: relative;
        width: 2.5rem;
        height: 1.5rem;
        border-radius: 9999px;
        background-color: var(--r5-surface-300);
        transition: background-color var(--r5-duration-normal);
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
      }

      :host([checked]) .track {
        background-color: var(--r5-primary);
      }

      .thumb {
        width: 1.125rem;
        height: 1.125rem;
        border-radius: 50%;
        background-color: white;
        transform: translateX(0.1875rem);
        transition: transform var(--r5-duration-normal);
        box-shadow: var(--r5-shadow-sm);
      }

      :host([checked]) .thumb {
        transform: translateX(1.1875rem);
      }

      input {
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
        margin: 0;
      }
    `
];
a([
  o({ type: Boolean, reflect: !0 })
], r.prototype, "checked", 2);
a([
  o({ type: Boolean, reflect: !0 })
], r.prototype, "disabled", 2);
a([
  o()
], r.prototype, "name", 2);
a([
  o()
], r.prototype, "value", 2);
r = a([
  p("ark-switch")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-switch-CHrQt2AZ.js.map
